import { useQuery } from '@tanstack/react-query';
import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FunctionComponent } from 'react';

import useLinkProps from '../../../hooks/use-link-props';
import getLoggedUser from '../../../utils/react-query/query-options/get-logged-user';
import Breadcrumbs from '../../modules/breadcrumbs';
import FeaturedLink from '../../ui/links/featured';
import PageTitle from '../../ui/typography/page-title';

import PasswordRecoverForm from './form';
import HelpInfo from './help-info';
import PasswordResetSchema from './seo';

const PasswordRecoverPage: FunctionComponent<TPageLogin> = () => {
  const { t } = useTranslation();
  const getLink = useLinkProps();
  const { locale = 'en', push } = useRouter();
  const { data: user, isLoading } = useQuery(...getLoggedUser({ locale }), {
    refetchOnMount: true,
    keepPreviousData: true,
    onSuccess: (data) => {
      if (data) {
        const link = getLink('private-area');
        push(link.href, link.as);
      }
    },
  });

  if (isLoading || user) {
    // TODO - loading page
    return (
      <main className="flex w-full h-full justify-center items-center">
        loading...
      </main>
    );
  } else {
    return (
      <main>
        <PasswordResetSchema breadcrumbs={[]} />
        <Breadcrumbs items={[]} currentPage={t('password-reset:recover')} />

        <div
          className={cx(
            'container',
            'mx-auto',
            'lg:my-12',
            'my-4',
            'grid',
            'lg:grid-cols-3',
            'pb-20'
          )}
        >
          <div className={cx('lg:col-span-2')}>
            <div className="pl-4">
              <PageTitle title={t('password-reset:recover')} />
              <p className={cx('text-base', '', 'lg:w-2/3')}>
                {t('password-reset:detail')}
              </p>
            </div>
            <PasswordRecoverForm />
            <div className="pl-4 mt-8">
              <Link {...getLink('login')} passHref legacyBehavior>
                <FeaturedLink>{t('password-reset:login')}</FeaturedLink>
              </Link>
            </div>
          </div>
          <HelpInfo />
        </div>
      </main>
    );
  }
};

export default PasswordRecoverPage;
